export var ExchangeActionEnum;
(function (ExchangeActionEnum) {
    ExchangeActionEnum["add"] = "Add";
    ExchangeActionEnum["change"] = "Change";
    ExchangeActionEnum["flown"] = "Flown";
    ExchangeActionEnum["keep"] = "Keep";
    ExchangeActionEnum["remove"] = "Remove";
})(ExchangeActionEnum || (ExchangeActionEnum = {}));
export var ExchangeForTypeEnum;
(function (ExchangeForTypeEnum) {
    ExchangeForTypeEnum["oneWay"] = "OneWay";
    ExchangeForTypeEnum["roundTrip"] = "RoundTrip";
})(ExchangeForTypeEnum || (ExchangeForTypeEnum = {}));
export var PassengerKey;
(function (PassengerKey) {
    PassengerKey["adult"] = "ADT";
    PassengerKey["adultPrivate"] = "JCB";
    PassengerKey["agelessChild"] = "CNN";
    PassengerKey["agelessChildPrivate"] = "JNN";
    PassengerKey["lapInfant"] = "INF";
    PassengerKey["lapInfantPrivate"] = "JNF";
    PassengerKey["seatedInfant"] = "INS";
    PassengerKey["seatedInfantPrivate"] = "JNS";
})(PassengerKey || (PassengerKey = {}));
export var AirExchangeShopResponse;
(function (AirExchangeShopResponse) {
    AirExchangeShopResponse["success"] = "AirExchangeShopSuccess";
    AirExchangeShopResponse["failure"] = "AirExchangeShopFailure";
})(AirExchangeShopResponse || (AirExchangeShopResponse = {}));
export var ExchangeModalState;
(function (ExchangeModalState) {
    ExchangeModalState[ExchangeModalState["ChangeAirports"] = 0] = "ChangeAirports";
    ExchangeModalState[ExchangeModalState["ChangeDateTime"] = 1] = "ChangeDateTime";
    ExchangeModalState[ExchangeModalState["ChangeFailed"] = 2] = "ChangeFailed";
    ExchangeModalState[ExchangeModalState["ChangeRequested"] = 3] = "ChangeRequested";
    ExchangeModalState[ExchangeModalState["ContactAirline"] = 4] = "ContactAirline";
    ExchangeModalState[ExchangeModalState["ContactSupport"] = 5] = "ContactSupport";
    ExchangeModalState[ExchangeModalState["GoToExchange"] = 6] = "GoToExchange";
    ExchangeModalState[ExchangeModalState["IneligibleForExchange"] = 7] = "IneligibleForExchange";
    ExchangeModalState[ExchangeModalState["ItineraryNotFound"] = 8] = "ItineraryNotFound";
    ExchangeModalState[ExchangeModalState["LoadFailed"] = 9] = "LoadFailed";
    ExchangeModalState[ExchangeModalState["LoadingOrProcessing"] = 10] = "LoadingOrProcessing";
    ExchangeModalState[ExchangeModalState["SliceSelection"] = 11] = "SliceSelection";
    ExchangeModalState[ExchangeModalState["TicketedVoidable"] = 12] = "TicketedVoidable";
    ExchangeModalState[ExchangeModalState["TooManyAttemptsSupport"] = 13] = "TooManyAttemptsSupport";
    ExchangeModalState[ExchangeModalState["LegacyTicketedVoidable"] = 14] = "LegacyTicketedVoidable";
})(ExchangeModalState || (ExchangeModalState = {}));
export var ExchangeScenario;
(function (ExchangeScenario) {
    ExchangeScenario["airlineControl"] = "AirlineControl";
    ExchangeScenario["bookingPending"] = "BookingPending";
    ExchangeScenario["canceled"] = "Canceled";
    ExchangeScenario["cancellationPending"] = "CancellationPending";
    ExchangeScenario["chfar"] = "Chfar";
    ExchangeScenario["containsRemarks"] = "ContainsRemarks";
    ExchangeScenario["departed"] = "Departed";
    ExchangeScenario["ftc"] = "Ftc";
    ExchangeScenario["nonChfar"] = "NonChfar";
    ExchangeScenario["exchangeable"] = "Exchangeable";
    ExchangeScenario["nonExchangeable"] = "NonExchangeable";
    ExchangeScenario["contactAirline"] = "ContactAirline";
    ExchangeScenario["contactCustomerService"] = "ContactCustomerService";
    ExchangeScenario["multiProvider"] = "MultiProvider";
})(ExchangeScenario || (ExchangeScenario = {}));
export var VoidScenario;
(function (VoidScenario) {
    VoidScenario["ticketedVoid"] = "TicketedVoid";
    VoidScenario["preTicketVoidable"] = "PreTicketVoidable";
    VoidScenario["notVoidable"] = "NotVoidable";
})(VoidScenario || (VoidScenario = {}));
export var FTCScenario;
(function (FTCScenario) {
    FTCScenario["available"] = "FtcAvailable";
    FTCScenario["expired"] = "FtcExpired";
    FTCScenario["redeemed"] = "FtcRedeemed";
})(FTCScenario || (FTCScenario = {}));
export var NonChfarScenario;
(function (NonChfarScenario) {
    NonChfarScenario["contactAirline"] = "ContactAirline";
    NonChfarScenario["contactCustomerService"] = "ContactCustomerService";
    NonChfarScenario["exchangeable"] = "Exchangeable";
    NonChfarScenario["nonExchangeable"] = "NonExchangeable";
    NonChfarScenario["ticketedVoidable"] = "TicketedVoidable";
    NonChfarScenario["preTicketVoidable"] = "PreTicketVoidable";
    NonChfarScenario["multiProvider"] = "MultiProvider";
})(NonChfarScenario || (NonChfarScenario = {}));
export var AirExchangePriceQuoteScheduleResponse;
(function (AirExchangePriceQuoteScheduleResponse) {
    AirExchangePriceQuoteScheduleResponse["success"] = "AirExchangePriceQuoteScheduleSuccess";
    AirExchangePriceQuoteScheduleResponse["failure"] = "AirExchangePriceQuoteScheduleFailure";
})(AirExchangePriceQuoteScheduleResponse || (AirExchangePriceQuoteScheduleResponse = {}));
export var AirExchangePriceQuotePollResponse;
(function (AirExchangePriceQuotePollResponse) {
    AirExchangePriceQuotePollResponse["success"] = "AirExchangePriceQuotePollSuccess";
    AirExchangePriceQuotePollResponse["pending"] = "AirExchangePriceQuotePollPending";
    AirExchangePriceQuotePollResponse["failure"] = "AirExchangePriceQuotePollFailure";
})(AirExchangePriceQuotePollResponse || (AirExchangePriceQuotePollResponse = {}));
export var AirExchangeBookScheduleResponse;
(function (AirExchangeBookScheduleResponse) {
    AirExchangeBookScheduleResponse["success"] = "AirExchangeBookScheduleSuccess";
    AirExchangeBookScheduleResponse["failure"] = "AirExchangeBookScheduleFailure";
})(AirExchangeBookScheduleResponse || (AirExchangeBookScheduleResponse = {}));
export var AirExchangeBookPollResponse;
(function (AirExchangeBookPollResponse) {
    AirExchangeBookPollResponse["success"] = "AirExchangeBookPollSuccess";
    AirExchangeBookPollResponse["pending"] = "AirExchangeBookPollPending";
    AirExchangeBookPollResponse["failure"] = "AirExchangeBookPollFailure";
    AirExchangeBookPollResponse["failureSentToCustomerService"] = "AirExchangeBookPollFailureSentToCustomerService";
})(AirExchangeBookPollResponse || (AirExchangeBookPollResponse = {}));
export var AirExchangeAgentFulfillResponse;
(function (AirExchangeAgentFulfillResponse) {
    AirExchangeAgentFulfillResponse["success"] = "AirExchangeAgentFulfillSuccess";
    AirExchangeAgentFulfillResponse["failure"] = "AirExchangeAgentFulfillFailure";
})(AirExchangeAgentFulfillResponse || (AirExchangeAgentFulfillResponse = {}));
//# sourceMappingURL=interfaces.js.map